<template>
  <div class="header">
    <div class="mainHeader">
      <!-- Out Icon -->
      <van-icon
        v-show="!homePage"
        @click="outPage"
        :style="{ color }"
        name="arrow-left"
      />
      <!-- title -->
      <h5 :style="{ color, marginLeft: !homePage ? '0.35rem' : '0' }">
        CrediSol
      </h5>
      <!-- Right option -->
      <div class="rightIcon">
        <van-icon
          v-show="!token"
          :style="{ color, marginRight: '0.24rem' }"
          name="contact-o"
          @click="openLogin"
        />
        <!-- My info List -->
        <el-dropdown trigger="click" @command="myInfoClick">
          <span class="el-dropdown-link">
            <van-icon
              v-show="token || $store.state.token"
              :style="{ color, marginRight: '0.24rem' }"
              name="contact-o"
            />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in myInfoList"
              :icon="item.icon"
              :key="index"
              :command="item.command"
              >{{ item.title }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <!-- other List -->
        <el-dropdown trigger="click" @command="otherClick">
          <span class="el-dropdown-link">
            <van-icon :style="{ color }" name="ellipsis" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in otherList"
              :icon="item.icon"
              :key="index"
              :command="item.command"
              >{{ item.title }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { outLogin, getInfor } from "../../utils/api/h5page";
export default {
  data() {
    return {
      token: null,
      myInfoList: [
        {
          title: "订单历史",
          icon: "el-icon-tickets",
          command: 1,
        },
        {
          title: "我的信息",
          icon: "el-icon-s-custom",
          command: 2,
        },
        {
          title: "退出登录",
          icon: "el-icon-switch-button",
          command: 3,
        },
      ],
      otherList: [
        {
          title: "Home",
          command: "/h5Page/home",
        },
        {
          title: "Ventajas del préstamo CrediSol",
          command: "#first",
        },
        {
          title: "REQUISITOS",
          command: "#second",
        },
        {
          title: "Pasos para solicitar",
          command: "#third",
        },
        {
          title: "Contáctenos",
          command: "#fourth",
        },
        {
          title: "Información sobre nosotros",
          command: "#last",
        },
        {
          title: "FAQ",
          command: "https://www.credisol.pe/h5/FAQ.html",
        },
        {
          title: "Política de Privacidad",
          command: "https://www.credisol.pe/h5/privacidad.html",
        },
        {
          title: "Protocolo de usuario",
          command: "https://www.credisol.pe/h5/use.html",
        },
      ],
    };
  },
  props: {
    color: {
      type: String,
      default: "#333333",
    },
    homePage: {
      type: Boolean,
    },
  },
  methods: {
    myInfoClick(val) {
      console.log(val);
      switch (val) {
        case 1:
          this.$router.push({ name: "historyList" });
          break;
        case 2:
          // 获取用户订单信息
          getInfor().then(({ data }) => {
            const { order_status } = data.data.loan_info;
            if (
              (order_status !== 0) &
              (order_status !== 3) &
              (order_status !== 8) &
              (order_status !== 10)
            ) {
              return this.$Toast(
                "Su estado actual: los datos no se pueden corregir"
              );
            } else {
              this.$router.push("/h5Page/registerInfo");
            }
          });
          break;
        case 3:
          outLogin().then(({ data }) => {
            // if (data.code == 0) {
            console.log("[ data ] >", data);
            this.$store.commit("LoginOut");
            localStorage.clear();
            this.$router.push("/h5Page/home");
            window.location.reload();
            // }
          });
          break;
      }
    },
    otherClick(val) {
      if (this.$route.path == val) return;
      // && this.$route.path == "/h5Page/home"
      if (val.includes("#") && document.querySelector(val)) {
        document.querySelector(val).scrollIntoView();
      } else if (val.includes("#") && !document.querySelector(val)) {
        this.$router.push("/h5Page/home");
        setTimeout(() => {
          document.querySelector(val).scrollIntoView();
        }, 0);
      } else if (val == "/h5Page/home") {
        this.$router.push("/h5Page/home");
      } else {
        // window.location.href = val;
        window.open(val);
      }
    },
    outPage() {
      this.$router.go(-1);
    },
    openLogin() {
      this.$emit("openlogin");
    },
    setToken() {
      this.token = localStorage.getItem("token");
    },
  },
  mounted() {},
  created() {
    this.token = localStorage.getItem("token");
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 10;
  padding-top: 0.5rem;
}
.mainHeader {
  z-index: 2011;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.96rem;
  // padding: 0 0.2rem 0 0.3rem;
  font-size: 0.4rem;
  font-weight: 700;
  background-color: transparent;
  h5 {
    font-family: Roboto, Roboto;
    font-size: 0.36rem;
    color: #333333;
    font-weight: 700;
  }
  .van-icon-ellipsis {
    transform: rotate(90deg) translateY(0.01rem);
  }
}
.van-popup--center {
  top: 1.5rem;
  right: 0.2rem;
  left: inherit;
  width: 40%;
  border-radius: 0.3rem;
  min-height: 30%;
  transform: none;
}
.el-dropdown {
  font-size: 0.4rem;
}
</style>
